import imgLog from '../../assets/images/logo.svg';
import Styles from './NotSupportedBrowser.module.scss';

export const NotSupportedBrowser = () => {
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.container}>
        <p className={Styles.header}>Sorry, your browser is not supported</p>

        <p className={Styles.text}>
          my prisma CLOUD is optimized for operation with Google Chrome and Firefox
        </p>

        <p className={Styles.text}>
          my prisma CLOUD est optimisé pour un fonctionnement avec Google Chrome et Firefox
        </p>

        <p className={Styles.text}>
          my prisma CLOUD ist für den Betrieb mit Google Chrome und Firefox optimiert
        </p>

        <img alt={'logo of loewenstein'} className={Styles.logo} src={imgLog} />
      </div>
    </div>
  );
};
